export { TrixEditor } from './TrixEditor';
export type { TrixEditorProps } from './TrixEditor.types';
